import { AdminPage } from "./adminPage";

export default AdminPage;
